import type { FC } from "react";
import { SwiperAmba } from "../../shared/components/SwiperAmba/SwiperAmba";
import classes from "./Ambassadors.module.scss";

export const Ambassadors: FC = () => {
	return (
		<div className={classes.wrapper}>
			<h2 className={classes.title}>Meet our ambassadors</h2>
			<SwiperAmba className={classes.swiper} />
		</div>
	);
};
